import { useAuth } from '../../hooks/useAuth.tsx';
import { motion } from 'framer-motion';
import { useHomepageStats } from '../../hooks/useHomepageStats';
// import MoldIcon from '../icons/MoldIcon.tsx';
import { useAppState } from '../../context/AppStateContext';
import MyTaskSection from './MyTaskSection.tsx';
import MoldStatsSection from '../Homepage/MoldStats.tsx';
import QuickActions from './QuickActions.tsx';
import MenuSection from './MenuSection.tsx';

interface HomeProps {
}

const Home: React.FC<HomeProps> = () => {
    const { user } = useAuth();
    const {
        getMoldOrderGroups,
    } = useAppState();
    const {
        moldStats,
        moldOrderStats,
        loading: statsLoading,
        error: statsError
    } = useHomepageStats();

    const moldOrderGroups = getMoldOrderGroups();
    // If stats are missing or an error occurred, show 'N/A' instead of numeric zeros
    const statsAvailable = !statsLoading && !!moldStats && !statsError;
    // Precompute work-order counts from server stats (or 'N/A' when unavailable)
    const ordersAvailable = !statsLoading && !!moldOrderStats && !statsError;

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100" data-cy="homepage">
            <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
                {/* My Tasks Overview Section - Notification Style */}
                {user && (
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                        className="mb-8"
                    >
                        <MyTaskSection
                            user={user}
                            moldOrderGroups={moldOrderGroups}
                            showSeeAllButton
                            previewLimit={3}
                        />
                    </motion.div>
                )}

                {/* Statistics Section with Molds and Work Orders in a compact layout */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="mb-12"
                >
                    <MoldStatsSection
                        moldOrderGroups={moldOrderGroups}
                        loading={statsLoading}
                        moldStats={moldStats}
                        moldOrderStats={moldOrderStats}
                        statsAvailable={statsAvailable}
                        ordersAvailable={ordersAvailable}
                    />
                </motion.div>

                {/* Quick Actions Section with Hover Animation */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                    className="mb-12"
                >
                    <QuickActions />
                </motion.div>

                {/* Responsive Card-Based Navigation Menu */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.4 }}
                >
                    <MenuSection />
                </motion.div>
            </div>
        </div>
    );
};

export default Home;
